import { render, staticRenderFns } from "./user-right-edit.vue?vue&type=template&id=496393b0"
import script from "./user-right-edit.vue?vue&type=script&lang=js"
export * from "./user-right-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports